"use client"
import { Container, Box, Typography, Grid } from "@mui/material"
import { StatsCards } from "./stats-cards"
import { CampaignsSection } from "./campaigns-section"
import { CollaborationsSection } from "./collaborations-section"
import { BlogsSection } from "./blogs-section"
import { PlaylistsSection } from "./playlists-section"
import { useDashboardData } from "../../hooks/use-dashboard-data"

const DashboardCreator = () => {
  const { studioAnalyticData, campaignDetails, collabRequest, blogs, officialPlaylists, loading } = useDashboardData()

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
          Dashboard
        </Typography>
      </Box> */}

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <StatsCards data={studioAnalyticData} loading={loading.stats} />
        </Grid>

        <Grid item xs={12}>
          <CampaignsSection campaigns={campaignDetails} loading={loading.campaigns} />
        </Grid>

        <Grid item xs={12}>
          <CollaborationsSection collaborations={collabRequest} loading={loading.collaborations} />
        </Grid>

        <Grid item xs={12}>
          <BlogsSection blogs={blogs} loading={loading.blogs} />
        </Grid>

        <Grid item xs={12}>
          <PlaylistsSection playlists={officialPlaylists} loading={loading.playlists} />
        </Grid>
      </Grid>
    </Container>
  )
}

export default DashboardCreator
